/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrPostSubmitResponse
 */
export interface RttrPostSubmitResponse {
    /**
     * 
     * @type {string}
     * @memberof RttrPostSubmitResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof RttrPostSubmitResponse
     */
    verified: boolean;
    /**
     * 
     * @type {number}
     * @memberof RttrPostSubmitResponse
     */
    pointsAwarded: number;
    /**
     * 
     * @type {number}
     * @memberof RttrPostSubmitResponse
     */
    submissionsThisRound: number;
    /**
     * 
     * @type {number}
     * @memberof RttrPostSubmitResponse
     */
    remainingSubmissions: number;
}

/**
 * Check if a given object implements the RttrPostSubmitResponse interface.
 */
export function instanceOfRttrPostSubmitResponse(value: object): value is RttrPostSubmitResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('verified' in value) || value['verified'] === undefined) return false;
    if (!('pointsAwarded' in value) || value['pointsAwarded'] === undefined) return false;
    if (!('submissionsThisRound' in value) || value['submissionsThisRound'] === undefined) return false;
    if (!('remainingSubmissions' in value) || value['remainingSubmissions'] === undefined) return false;
    return true;
}

export function RttrPostSubmitResponseFromJSON(json: any): RttrPostSubmitResponse {
    return RttrPostSubmitResponseFromJSONTyped(json, false);
}

export function RttrPostSubmitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrPostSubmitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'verified': json['verified'],
        'pointsAwarded': json['pointsAwarded'],
        'submissionsThisRound': json['submissionsThisRound'],
        'remainingSubmissions': json['remainingSubmissions'],
    };
}

export function RttrPostSubmitResponseToJSON(json: any): RttrPostSubmitResponse {
    return RttrPostSubmitResponseToJSONTyped(json, false);
}

export function RttrPostSubmitResponseToJSONTyped(value?: RttrPostSubmitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'verified': value['verified'],
        'pointsAwarded': value['pointsAwarded'],
        'submissionsThisRound': value['submissionsThisRound'],
        'remainingSubmissions': value['remainingSubmissions'],
    };
}

